import React, { Component } from 'react'
import { t } from 'i18next'

import IconTrophyGold from '../svg/icon-trophygold'
import IconTrophySilver from '../svg/icon-trophysilver'
import IconTrophyBronze from '../svg/icon-trophybronze'
import './ranking-top.css'

class RankingTop extends Component {
  render() {
    const { top } = this.props

    const labels = [
      {
        svg: IconTrophyGold,
        position: t('ranking.top.first'),
        color: '#F8B64C'
      },
      {
        svg: IconTrophySilver,
        position: t('ranking.top.second'),
        color: '#D3D3D3'
      },
      {
        svg: IconTrophyBronze,
        position: t('ranking.top.third'),
        color: '#BA7B42'
      }
    ]

    return (
      <ul className="winners text-center">
        {top.map((t, index, color) => {
          const Icon = labels[index].svg
          const position = labels[index].position
          const style = labels[index].color

          return (
            <li key={index} className="winner">
              <Icon className="icon-trophy" />
              <h4 style={{ color: style }}>{position}</h4>
              <h2>{t.name}</h2>
            </li>
          )
        })}
      </ul>
    )
  }
}

export default RankingTop



// WEBPACK FOOTER //
// ./src/components/rankingTop.js